import React from "react";
import {Navigate} from "react-router-dom";

const ProtectedRoute = ({children, allowedRoles}) => {
    const token =
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("accessToken");

    const role =
        localStorage.getItem("role") ||
        sessionStorage.getItem("role");


    if (!token) return <Navigate to="/" replace/>;


    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/403" replace/>;
    }

    return children;
};

export default ProtectedRoute;
